import React from "react";

import { FrontendOrganization } from "node-library/dist/portal";
import { useTranslation } from "react-i18next";
import OrganizationCell from "./organizationCell";

interface Props {
	organizations: Array<FrontendOrganization>;
	goToViewOrgDetails: (org: FrontendOrganization) => void;
	setDeleteOrgConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function ViewOrgsTable(props: Props) {
	const { t: translation } = useTranslation();

	const {
		organizations,
		goToViewOrgDetails,
		setDeleteOrgConfirmOpen,
		setProceedAction,
	} = props;

	const orgCells: Array<React.ReactNode> = organizations
		? organizations.map((org: FrontendOrganization, index: number) => {
				return (
					<OrganizationCell
						key={org.organizationId}
						organization={org}
						goToViewOrgDetails={() => goToViewOrgDetails(org)}
						// discardUnstartedOrder={() => {
						// 	setProceedAction(() => () => discardUnstartedOrder(order));
						// 	setDiscardOrderConfirmOpen(true);
						// }}
					/>
				);
		  })
		: [];

	return <div className="view-order-grid-table">{orgCells}</div>;
}
